import { render, staticRenderFns } from "./expansion-panels.vue?vue&type=template&id=187257b6"
import script from "./expansion-panels.vue?vue&type=script&lang=js"
export * from "./expansion-panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports